// Streak tracking - consecutive correct Predict-stage guesses (crowd match).
// Persisted in localStorage. Reset on wrong prediction. No time limit.

const KEY_CURRENT = "cs.streak.current";
const KEY_BEST = "cs.streak.best";
const KEY_LAST_STREAK = "cs.streak.last"; // last game's ending streak

export const getStreak = () => {
  const v = parseInt(localStorage.getItem(KEY_CURRENT) || "0", 10);
  return Number.isNaN(v) ? 0 : v;
};
export const getBestStreak = () => {
  const v = parseInt(localStorage.getItem(KEY_BEST) || "0", 10);
  return Number.isNaN(v) ? 0 : v;
};
export const getLastStreak = () => {
  const v = parseInt(localStorage.getItem(KEY_LAST_STREAK) || "0", 10);
  return Number.isNaN(v) ? 0 : v;
};

// Register a prediction result. Returns { current, best, brokeRecord }.
export const registerPrediction = (isCorrect) => {
  let current = getStreak();
  let best = getBestStreak();
  let brokeRecord = false;
  if (isCorrect) {
    current += 1;
    if (current > best) {
      best = current;
      brokeRecord = true;
      localStorage.setItem(KEY_BEST, String(best));
    }
    localStorage.setItem(KEY_CURRENT, String(current));
  } else {
    if (current > 0) localStorage.setItem(KEY_LAST_STREAK, String(current));
    current = 0;
    localStorage.setItem(KEY_CURRENT, "0");
  }
  return { current, best, brokeRecord };
};

// Called at end of a game session to snapshot the final ending streak.
export const snapshotSessionEnd = () => {
  const current = getStreak();
  if (current > 0) localStorage.setItem(KEY_LAST_STREAK, String(current));
};

export const resetStreak = () => {
  localStorage.setItem(KEY_CURRENT, "0");
};
